/** @format */

import React, {useContext} from 'react';
import {Loading} from 'frontier-utilities';
import {SearchContext} from 'frontier/components/search/index';

const LoadMore = props => {
    const handleLoadMore = () => {
        props.onSearch({page: {$set: props.page + 1}});
    };

    // pass ctx to children
    if (props.children) {
        return React.cloneElement(props.children, {
            ...props,
            onClick: handleLoadMore
        });
    }

    if (props.pending) {
        return <Loading message="Loading..." height="20vh" />;
    } else if (props.nextPage) {
        return (
            <button onClick={handleLoadMore} className="btn btn-secondary  tw-mx-auto d-block mb-1">
                Load More
            </button>
        );
    } else if (props.itemCount > 0) {
        // If there are no results... well, don't worry about it
        return <div className="alert alert-info">No more results</div>;
    }
    return null;
};

function LoadMoreContextual({children}) {
    const ctx = useContext(SearchContext);

    return (
        <LoadMore
            handleChangePaginationSize={ctx.handleChangePaginationSize}
            curPaginationSize={ctx.paginationSize}
            itemCount={ctx.listItems?.length}
            nextPage={ctx.nextPage}
            onSearch={ctx.onSearch}
            pending={ctx.pending}
            children={children}
            page={ctx.page}
        />
    );
}

export default LoadMore;
export {LoadMoreContextual};
